import React from 'react';

const GuidedResponseFormElement = ({ children }) => {
	return <div className="form-element">{children}</div>;
};

export default GuidedResponseFormElement